import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const MerchCartContext = createContext(null);
const KEY = "skk_merch_cart_v1";

const load = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const MerchCartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { console.warn("merch cart could not be saved", e); }
  }, [items]);

  const add = useCallback((p, size, color, qty = 1) => {
    const key = `${p.product_id}-${size || ""}-${color || ""}`;
    setItems((c) => {
      const ex = c.find((i) => i.key === key);
      if (ex) return c.map((i) => (i.key === key ? { ...i, quantity: i.quantity + qty } : i));
      return [...c, {
        key, product_id: p.product_id, name: p.name, price: Number(p.retail_price),
        image: p.images?.[0] || "", size: size || null, color: color || null, quantity: qty,
      }];
    });
    setOpen(true);
    toast.success(`Added ${p.name} to your cart`);
  }, []);

  const remove = useCallback((key) => setItems((c) => c.filter((i) => i.key !== key)), []);
  const setQty = useCallback((key, q) => setItems((c) => c.map((i) => (i.key === key ? { ...i, quantity: Math.max(1, q) } : i))), []);
  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((a, i) => a + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((a, i) => a + i.price * i.quantity, 0), [items]);

  const value = useMemo(
    () => ({ items, add, remove, setQty, clear, count, subtotal, open, setOpen }),
    [items, add, remove, setQty, clear, count, subtotal, open]
  );

  return <MerchCartContext.Provider value={value}>{children}</MerchCartContext.Provider>;
};

export const useMerchCart = () => useContext(MerchCartContext);
